var _g, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgText(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 210,
    height: 289,
    viewBox: "0 0 210 289",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle Copy 3",
    filter: "url(#filter0_d_569_4925)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 9,
    width: 190,
    height: 269,
    rx: 20,
    fill: "#E2E8F0"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle Copy 32",
    x: 21,
    y: 209,
    width: 168,
    height: 6,
    rx: 3,
    fill: "#CBD5E1"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle Copy 42",
    x: 21,
    y: 109,
    width: 168,
    height: 6,
    rx: 3,
    fill: "#CBD5E1"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle Copy 33",
    x: 21,
    y: 159,
    width: 168,
    height: 6,
    rx: 3,
    fill: "#CBD5E1"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle Copy 43",
    x: 21,
    y: 59,
    width: 168,
    height: 6,
    rx: 3,
    fill: "#CBD5E1"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle Copy 52",
    x: 21,
    y: 36,
    width: 90,
    height: 12,
    rx: 6,
    fill: "#CBD5E1"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle Copy 34",
    x: 21,
    y: 219,
    width: 168,
    height: 6,
    rx: 3,
    fill: "#CBD5E1"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle Copy 44",
    x: 21,
    y: 119,
    width: 168,
    height: 6,
    rx: 3,
    fill: "#CBD5E1"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle Copy 35",
    x: 21,
    y: 169,
    width: 168,
    height: 6,
    rx: 3,
    fill: "#CBD5E1"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle Copy 45",
    x: 21,
    y: 69,
    width: 168,
    height: 6,
    rx: 3,
    fill: "#CBD5E1"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle Copy 36",
    x: 21,
    y: 229,
    width: 168,
    height: 6,
    rx: 3,
    fill: "#CBD5E1"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle Copy 46",
    x: 21,
    y: 129,
    width: 168,
    height: 6,
    rx: 3,
    fill: "#CBD5E1"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle Copy 37",
    x: 21,
    y: 179,
    width: 168,
    height: 6,
    rx: 3,
    fill: "#CBD5E1"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle Copy 47",
    x: 21,
    y: 79,
    width: 168,
    height: 6,
    rx: 3,
    fill: "#CBD5E1"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle Copy 38",
    x: 21,
    y: 239,
    width: 168,
    height: 6,
    rx: 3,
    fill: "#CBD5E1"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle Copy 48",
    x: 21,
    y: 139,
    width: 168,
    height: 6,
    rx: 3,
    fill: "#CBD5E1"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle Copy 39",
    x: 21,
    y: 189,
    width: 168,
    height: 6,
    rx: 3,
    fill: "#CBD5E1"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle Copy 49",
    x: 21,
    y: 89,
    width: 168,
    height: 6,
    rx: 3,
    fill: "#CBD5E1"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle Copy 40",
    x: 21,
    y: 249,
    width: 168,
    height: 6,
    rx: 3,
    fill: "#CBD5E1"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle Copy 50",
    x: 21,
    y: 149,
    width: 168,
    height: 6,
    rx: 3,
    fill: "#CBD5E1"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle Copy 41",
    x: 21,
    y: 199,
    width: 168,
    height: 6,
    rx: 3,
    fill: "#CBD5E1"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle Copy 51",
    x: 21,
    y: 99,
    width: 168,
    height: 6,
    rx: 3,
    fill: "#CBD5E1"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_569_4925",
    x: 0,
    y: 0,
    width: 210,
    height: 289,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.937255 0 0 0 0 0.937255 0 0 0 0 0.937255 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_569_4925"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_569_4925",
    result: "shape"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgText);
export default __webpack_public_path__ + "static/media/text.fe732484f83dc192b9b41ded9aba764d.svg";
export { ForwardRef as ReactComponent };